import '@assets/main.css';
import '@pequity/shared/plugins/dayjs';
import { vWTooltip } from '@pequity/shared/ui';
import { clearIsOidcSession, isOidcSession } from '@pequity/shared/utils/oidc';
import { preloadWaypointComponents } from '@pequity/shared/utils/waypoint';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from '@/App.vue';
import { setupAxiosInterceptors } from '@/plugins/axios';
import { I18nPlugin } from '@/plugins/i18n';
import { setupLayoutComponents } from '@/plugins/layout';
import { setupSentry } from '@/plugins/sentry';
import { router } from '@/router';
import { scheduleOidcRefresh } from '@/utils/oidcTokenRefresh';

// Set the AG Grid Enterprise license key from SynergConfig.
// Imported dynamically to keep AG Grid out of the startup bundle; the import starts
// right away so only SynergConfig gates setting the key.
const agGridLicense = import('@pequity/shared/plugins/ag-grid');
__SYNERG_READY__.then(async (cfg) => {
  preloadWaypointComponents(cfg);

  const { setupAgGridLicense } = await agGridLicense;
  setupAgGridLicense(cfg.getKey('ag-grid-enterprise'));
});

const pinia = createPinia();

setupAxiosInterceptors();

const app = createApp(App);

setupLayoutComponents(app);

setupSentry(app, router);

app.use(pinia);

// A staff mode tab opens at /saml/login and inherits is_oidc_session=true from the
// original OIDC tab via shared localStorage (same origin, no subdomains). Clear it
// immediately so the OIDC refresh machinery never starts in this tab.
if (window.location.pathname.includes('/saml/login')) {
  clearIsOidcSession();
}

if (isOidcSession()) {
  scheduleOidcRefresh();
}

app.use(router);

app.use(VueQueryPlugin, {
  enableDevtoolsV6Plugin: true,
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  },
});

app.use(I18nPlugin);

app.directive('w-tooltip', vWTooltip);

app.mount('#app');
